module.exports = "/images/lr.svg?f902e9b5a8de72721a3df1f59de70aa5";